import React, { useState, useEffect } from "react";

// Material UI
import { Button, Grid, Paper } from "@mui/material";
import Add from "@mui/icons-material/Add";
import DialogActions from "@mui/material/DialogActions";

// Components
import { DataGrid, EditButton, DeleteButton } from '@arredo/reactjs-ui';
import Input from "../../../../components/inputs/input";
import Modal from "../../../../components/modal/index";
import Dropdown from "../../../../components/inputs/dropdown";

// Hooks
import useStyles from "../styles";
import useJurisdictions from "../../../../hooks/billing/useJurisdictions";

import { FilterCountries as AceptedJuridictions } from "../../../../models/CountriesEntity";
import { utils } from "../../../../utils/utils";

const columns = [
  {
    field: 'stateId',
    header: 'Provincia',
    sizes: { xs: 2 }
  },
  {
    field: 'exemptionRate',
    header: 'Porcentaje',
    sizes: { xs: 3 }
  },
  {
    field: 'startDate',
    header: 'Desde',
    sizes: { xs: 3 }
  },
  {
    field: 'endDate',
    header: 'Hasta',
    sizes: { xs: 3 }
  }
]


const CreateUpdateExemption = ({ exemption, modalProps, onSave }) => {
  const { jurisdictions } = useJurisdictions();
  const [item, setItem] = useState(exemption || null);
  const [juridictionFitered, setJuridictionFiltered] = useState([]);

  useEffect(() => {
    if (jurisdictions) {
      const filtered = jurisdictions
        .filter(j => AceptedJuridictions.some(a => a.value === j.code))

      setJuridictionFiltered(filtered)
    }
  }, [jurisdictions])

  const isValidExemption = () => {
    if (!item) return false;

    const rate = item.exemptionRate;

    if (rate < 0 || rate > 100)
      return false;

    if (!item.stateId)
      return false;

    return true;
  };

  const handleInputChange = (event) =>
    setItem({
      ...item,
      [event.target.name]: event.target.value,
    });

  const handleInputChangeFloat = (event) =>
    setItem({
      ...item,
      [event.target.name]: parseFloat(event.target.value),
    });

  return (
    <Modal
      fullWidth
      dividers
      title="Agregar Juridiccion"
      {...modalProps}
      customButtons={() =>
        <DialogActions>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => modalProps.onClose()}
          >
            Cancelar
          </Button>
          <Button
            disabled={!isValidExemption()}
            color="primary"
            variant="contained"
            onClick={() => onSave(item)}
          >
            Guardar
          </Button>
        </DialogActions>
      }
    >
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <Input
            fullWidth
            required
            type="number"
            label="Porcentaje exención/exclusión"
            name="exemptionRate"
            onChange={handleInputChangeFloat}
            value={item?.exemptionRate || ''}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <Dropdown
            fullWidth
            required
            label="Provincia"
            name="stateId"
            getOptionLabel={(option) => option?.description}
            getOptionValue={(option) => option?.id}
            values={juridictionFitered}
            onChange={handleInputChange}
            value={item?.stateId || ""}
            disabled={juridictionFitered.length === 0}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <Input
            fullWidth
            name="startDate"
            label="Desde"
            type="date"
            value={utils.formatDateForPicker(item?.startDate ?? "", false)}
            onChange={handleInputChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <Input
            fullWidth
            name="endDate"
            label="Hasta"
            type="date"
            value={utils.formatDateForPicker(item?.endDate || "", false)}
            onChange={handleInputChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};

const ExemptionIibb = ({ exemptions, handleChange, disabled }) => {
  const { classes } = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const [currentExemption, setCurrentExemption] = useState(null);

  const handleDelete = (item) => {
    exemptions = exemptions.filter((e) => e.id !== item.id);
    handleChange(exemptions);
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setCurrentExemption(null);
  };

  const handleOpenModalUpdate = (item) => {
    item.exemptionRate = item.exemptionRate ? item.exemptionRate : 100;
    setCurrentExemption(item);
    setOpenModal(true);
  };

  const onSaveItem = (item) => {
    if (!exemptions) exemptions = [];

    let newExemptions = [];
    if (item.id) {
      newExemptions = exemptions.map((e) => e.id === item.id ? item : e);
    } else {
      item.id =
        "temp" +
        item.stateId +
        item.exemptionRate +
        item.startDate +
        item.endDate;

      newExemptions = [...exemptions, item]
    }

    handleChange(newExemptions);
    setOpenModal(false);
  };

  return (
    <>
      {openModal && (
        <CreateUpdateExemption
          exemption={currentExemption}
          onSave={onSaveItem}
          modalProps={{
            open: openModal,
            onClose: handleModalClose,
          }}
        />
      )}
      <Paper className={classes.paper} variant="outlined">
        <div className={classes.column}>
          <DataGrid
            columns={columns}
            rows={exemptions || []}
            actions={({ row }) => (
              <>
                {
                  !disabled &&
                  <EditButton
                    onClick={() => handleOpenModalUpdate(row)}
                  />
                }
                {
                  !disabled &&
                  <DeleteButton
                    onClick={() => handleDelete(row)}
                  />
                }
              </>
            )}
          />
          {!disabled && (
            <Button
              onClick={() => setOpenModal(true)}
              variant="outlined"
              color="primary"
              startIcon={<Add />}
            >
              Agregar exención
            </Button>
          )}
        </div>
      </Paper>
    </>
  );
};

export default ExemptionIibb;
